import I18n from 'I18n';
import { PageTypes, Paths } from '../../../components/RoutesPublic';
import { addLabelAndVerifyBadge } from '../navUtils';
import memoize from 'react-utils/memoize';
import { navigation } from 'developer-docs-source/navigation';
export const uiComponentsNavConfig = memoize(() => {
  const commonPath = `${Paths.REFERENCE}/ui-components`;
  const nav = navigation[commonPath];
  const navigationItems = nav.items.map(item => addLabelAndVerifyBadge(item, commonPath));
  const config = {
    commonPath,
    badge: 'BETA',
    locatorPageType: PageTypes.REFERENCE,
    hasMdxOverview: true,
    sectionLabel: I18n.text('developer-docs-ui.navigation.reference.uiComponents'),
    items: navigationItems
  };
  return config;
});